import {
	FEATURED_DARES_ADMIN_FORM_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'

import addFeaturedDare from 'root/src/client/logic/project/thunks/addFeaturedDare'
import deleteFeaturedDare from 'root/src/client/logic/project/thunks/deleteFeaturedDare'

export default {
	[FEATURED_DARES_ADMIN_FORM_MODULE_ID]: [
		{
			action: addFeaturedDare,
			// onSuccess
		},
		{
			action: deleteFeaturedDare,
			// onSuccess
		},
	],
}
